<template>
  <layout-report :renderBackAndForthFooter="false" :isProgressDone="true" :showFooter="false">
    <v-container class="padded">
      <v-row>
        <v-col cols="12">
          <v-card flat max-width="515">
            <v-card-title class="text-h4 px-0">
              {{ title }}
            </v-card-title>

            <v-card-subtitle v-html="description" class="pl-0"></v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="!isLoading">
        <v-col cols="12" class="px-1" v-for="(myAffiliate, i) in myAffiliates" :key="i">
          <thg-invite-friends-card :myAffiliate="myAffiliate" />
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col offset="0" cols="12">
          <v-card class="mb-10" max-width="515">
            <v-skeleton-loader class="mx-auto" type="article, actions"></v-skeleton-loader>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </layout-report>
</template>

<script lang="ts">
import ThgInviteFriendsCard from "@/components/thg/ThgInviteFriendsCard.vue";
import Debug from "@/components/utility/Debug.vue";
import LayoutReport from "@/layouts/LayoutReport.vue";
import { AffiliateModule } from "@/store/modules/affiliate.store";
import { Component, Vue } from "vue-property-decorator";
import { getDefaultPartnerColor } from "@/lib/getDefaultPartnerColor";

@Component({
  components: { LayoutReport, Debug, ThgInviteFriendsCard }
})
export default class ThgInviteFriends extends Vue {
  isLoading = false;

  get title() {
    return this.$t("report.thgInviteFrinds.title");
  }

  get description() {
    return this.$t("report.thgInviteFrinds.description");
  }

  get myAffiliates() {
    return AffiliateModule.myAffiliates;
  }

  async mounted() {
    this.isLoading = true;
    try {
      await AffiliateModule.getMyAffiliates();
    } catch (error) {
      this.$log.error(error);
      this.$toast.error("Fehler beim Laden der Affilates");
    } finally {
      this.isLoading = false;
    }
  }

  get color() {
    return getDefaultPartnerColor();
  }
}
</script>
